// extracted by mini-css-extract-plugin
export default {"base":"Skeleton-module-base","shineLines":"Skeleton-module-shineLines"};